import styled from 'styled-components';

import Colors from '../../../themes/Colors';
const NoAudienceDataAlertHolder = styled.div`
  .no-audience-data-alert {
    background-color: ${Colors.tintWarning};
    border: 1px solid ${Colors.border};
    padding: 10px;
    margin: 10px;
    border-radius: 4px;
  }

  .no-audience-data-alert__container {
    display: flex;
    align-items: center;
  }

  .no-audience-data-alert__icon-container {
    margin-right: 10px;
  }

  .no-audience-data-alert__message {
    font-size: 14px;
    color: ${Colors.textSecondary};
  }
`;

export default NoAudienceDataAlertHolder;
